module.exports = __webpack_public_path__ + "img/thank_you_page.113941bd.png";